module.exports = __webpack_public_path__ + "static/media/live-tv-icon.5df2f86a.svg";